<template>
    <header>
        <div class="nav__wrapper d-flex">
            <div class="navbar w-100 p-0">
                <div class="nav__logo py-2">
                    <router-link :to="{ name: 'home' }" class="navbar-brand">
                        <img src="@/assets/logo.gif" class="img-fluid">
                    </router-link>
                </div>
                <div class="nav__items flex-1 d-flex justify-content-between align-items-center h-100 py-2 px-4">
                    <div class="nav__brand text-left">
                        <p class="bigger mb-0">Wohnungsdatenbank</p>
                        <p class="mb-0">Albert-Ludwigs-Universität Freiburg</p>
                    </div>
                    <div class="nav">
                        <div v-if="loggedIn" class="nav-item--wrapper d-flex align-items-center">
                            <div class="lang__switcher mr-5" v-if="userStatus == 1 && showLangSwitch">
                                <a v-on:click="changeLang('de')" v-bind:class="{ active: l == 'de' }">DE</a>|<a
                                    v-on:click="changeLang('en')" v-bind:class="{ active: l == 'en' }">EN</a>
                            </div>
                            <template v-if="userStatus == 1">
                                <router-link class="" :to="{ name: 'profil'}">
                                    <mdb-icon far icon="user-circle"/>
                                    {{$t('Global.Profil')}}
                                </router-link>
                                |
                            </template>
                            <template v-else>
                                <router-link class="" :to="{ name: 'profilVermieter'}">
                                    <mdb-icon far icon="user-circle"/>
                                    {{$t('Global.Profil')}}
                                </router-link>
                                |
                            </template>

                            <a @click="logout">Logout</a>
                        </div>
                        <div v-else class="nav-item--wrapper d-flex align-items-center">
                            <div class="lang__switcher mr-5" v-if="showLangSwitch">
                                <a v-on:click="changeLang('de')" v-bind:class="{ active: l == 'de' }">DE</a>|<a
                                    v-on:click="changeLang('en')" v-bind:class="{ active: l == 'en' }">EN</a>
                            </div>
                            <router-link :to="{ name: 'login'}" v-if="userStatus == 1">Login</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>

</template>

<script>
    import {authComputed} from '../../helpers/helper.js';
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                adminmenu: 1,
                lang: ['de', 'en']
            }
        },
        props: {
            l: String
        },
      mounted() {
        if(this.user){
          if(this.user.type == 2){
            this.changeLang('de');
          }
        }
      },
      methods: {
            subIsActive(input) {
                const paths = Array.isArray(input) ? input : [input]
                return paths.some(path => {
                    return this.$route.path.indexOf(path) === 0 // current path starts with this path string
                })
            },
            logout: function () {
                this.$store.dispatch("logout")
                    .then(() => this.$router.push("/login"))
                    .catch(err => console.log(err));
            },
            changeLang: function (lang) {

                this.$currentLang.value = lang;
                this.$parent.changeLang();
                this.$root.$i18n.locale = lang;

                this.$store.commit('updateLanguage', lang.toUpperCase());

            }
        },
        watch:{
            lang:{
                handler: function (val, oldVal) {

                }
            },
            userStatus: {
              handler: function (val, oldVal) {
                if(val == 2){
                  this.changeLang('de');
                }
              }
            }
        },
        computed: {
            ...authComputed,
            showLangSwitch() {
              if(this.$route.name == 'registerVermieter' ){
                this.changeLang('de');
              }
              return this.$route.name !== 'registerVermieter';
            }
        }

    };
</script>
<style scoped lang="scss">
    .nav__wrapper {
        margin-bottom: 50px;
    }

    .navbar {
        background-color: #004a99;
        color: white;
        @media(max-width: 480px){
            flex-wrap: nowrap;
        }
        .nav__logo {
            background-color: white;
            @media(max-width: 480px){
                width: 40%;
            }
        }

        p {
            font-size: 18px;
            line-height: 110%;
        }

        .bigger {
            font-weight: bold;
            font-size: 120%;
        }

        .nav__brand {
            @media(max-width: 480px){
                display: none;
            }
        }

        .nav {
            .nav-item--wrapper {
                font-size: 26px;
            }

            a {
                margin: 0px 10px;
                font-size: 18px;
                color: white;
                font-weight: bold;
                position: relative;
                @media(max-width: 480px){
                    font-size: 14px;
                }
                &:hover {
                    color: #FF3547;
                }
            }

            i {
                margin-right: 7px;
                font-size: 28px;
                position: absolute;
                left: -10px;
                top: 50%;
                transform: translate(-100%, -50%);
            }
        }
    }

    .side-nav a {
        padding-left: 0px !important;
    }

    .nav-item.active a {
        background-color: rgba(0, 0, 0, 0.15);
    }

    .lang__switcher {
        a {
            &.active {
                color: #FF3547;
            }
        }
    }
</style>
